<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-tabs v-model="tabIndex">
          <b-tab v-for="(v, k) in $data._.each(items)" :key="k" :title="tabMapping[k]">
            <receipt-account-table-detail :fields="fields[k]" :items="v" @updateData="getData" />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueNotifications from 'vue-notifications'
import { Events } from '../../../events.js'
import _ from 'lodash'
import ReceiptAccountTableDetail from './ReceiptAccountTableDetail'

export default {
  name: 'ReceiptAccountList',
  components: {
    ReceiptAccountTableDetail
  },
  data: () => {
    return {
      _: _,
      tabIndex: 0,
      fetching: false,
      type: 0,
      items: [],
      tabMapping: {
        1: 'Bank Account',
        2: 'Wallet Address',
        3: 'Crypto Address'
      },
      fields: {
        1: [
          { key: 'sn', label: 'S.No' },
          { key: 'bankLogo', label: 'Bank Logo' },
          { key: 'bankName', label: 'Bank Name' },
          { key: 'receiptBankAccount', label: 'Receipt Bank Account' },
          { key: 'paylinkUrl', label: 'Pay Link Url' },
          { key: 'qrCode', label: 'Qrcode' },
          { key: 'status', label: 'OCMS Status' },
          { key: 'Action', label: 'Action' }
        ],
        2: [
          { key: 'sn', label: 'S.No' },
          { key: 'bankLogo', label: 'Wallet Logo' },
          { key: 'bankName', label: 'Wallet Name' },
          { key: 'receiptBankAccount', label: 'Receipt Wallet Number' },
          { key: 'paylinkUrl', label: 'Pay Link Url' },
          { key: 'qrCode', label: 'Qrcode' },
          { key: 'status', label: 'OCMS Status' },
          { key: 'Action', label: 'Action' }
        ],
        3: [
          { key: 'sn', label: 'S.No' },
          { key: 'bankLogo', label: 'Crypto Logo' },
          { key: 'bankName', label: 'Crypto Name' },
          { key: 'receiptBankAccount', label: 'Wallet Address' },
          { key: 'paylinkUrl', label: 'Pay Link Url' },
          { key: 'qrCode', label: 'Qrcode' },
          { key: 'status', label: 'OCMS Status' },
          { key: 'Action', label: 'Action' }
        ]
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      try {
        this.fetching = true
        const [bankData, qrData] = await Promise.all([
          this.$http.get(this.API_ENDPOINT + `/payment/bank/account/getReceiptBankList?type=${this.type}`, { headers: { 'Content-Type': 'application/json' } }),
          this.$http.post(this.API_ENDPOINT + '/payment/manual/paylink/getList', { headers: { 'Content-Type': 'application/json' } })
        ])
        let combinedData = bankData.data.items.map(x => {
          const qr = qrData.data.data.find(y => y.receiptAccountId === x.receiptAccountId)
          if (qr) {
            return { ...x, bankLogo: qr.bankLogo, paylinkUrl: qr.paylinkUrl, qrCode: qr.qrCode }
          } else {
            return { ...x, bankLogo: '', paylinkUrl: '', qrCode: '' }
          }
        })
        this.items = _.groupBy(combinedData, 'AccountType')
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        this.fetching = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/payment/bank/ReceiptAccountTable.vue